document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('popup');
  const close = document.querySelector('.close');
  const minWidthQuery = window.matchMedia("(min-width: 600px)");

  // Show the popup
  function showPopup() {
    popup.style.display = 'block';
    setTimeout(() => {
      popup.classList.add('show');
    }, 10);
  }

  // Hide the popup
  function hidePopup() {
    popup.style.display = 'none';
    popup.classList.remove('show');
  }

  // Close on 'X' click
  close.onclick = hidePopup;

  // Close on clicking outside popup content
  window.onclick = function(event) {
    if (event.target === popup) {
      hidePopup();
    }
  };

  // Show popup on every page load if min-width condition is met
  if (minWidthQuery.matches) {
    setTimeout(showPopup, 2000); // 2-second delay
  }
});
